<template>
  <base-layout>
    <template #sidebar>
      <ui-settings-sidebar />
    </template>
    <template #breadcrumbs>
      <ui-breadcrumbs title="Настройки" />
    </template>
    <div class="bg-white shadow-sm p-3">
      <div class="row">
        <el-form
          ref="login_form"
          v-loading="form.processing"
          :model="form"
          label-position="top"
          class="col-12 col-lg-6"
          @submit.native.prevent="submit"
        >
          <el-form-item
            label="Email"
            prop="email"
          >
            <el-input
              id="email"
              v-model="form.email"
              autofocus
              type="email"
              @keyup.enter.native="submit"
            />
          </el-form-item>

          <el-form-item
            label="Телефон"
            prop="phone"
          >
            <el-input
              id="phone"
              v-model="form.phone"
              @keyup.enter.native="submit"
            />
          </el-form-item>

          <el-form-item
            label="ВКонтакте"
            prop="vk"
          >
            <el-input
              id="vk"
              v-model="form.vk"
              @keyup.enter.native="submit"
            />
          </el-form-item>

          <el-form-item
            label="Пример HTML"
            prop="example_html"
          >
            <v-ace-editor
              v-model:value="form.example_html"
              lang="html"
              theme="chrome"
              style="height: 200px"
            />
          </el-form-item>

          <ui-editor v-model="form.example_html" />

          <hr>

          <el-form-item
            label="TinyMce ключ"
            prop="tinymce_key"
          >
            <el-input
              id="tinymce_key"
              v-model="form.tinymce_key"
              @keyup.enter.native="submit"
            />
          </el-form-item>
          <h5>Настройки дадата</h5>
          <p class="text-gray">
            Ключ можно получить в <a
              href="https://dadata.ru/profile/"
              target="_blank"
            >личном кабинете dadata.ru</a>
          </p>
          <el-form-item
            label="DADATA токен"
            prop="dadata_token"
          >
            <el-input
              id="tinymce_key"
              v-model="form.dadata_token"
              @keyup.enter.native="submit"
            />
          </el-form-item>

          <el-form-item
            label="DADATA секретный ключ"
            prop="dadata_secret"
          >
            <el-input
              id="tinymce_key"
              v-model="form.dadata_secret"
              @keyup.enter.native="submit"
            />
          </el-form-item>

          <el-form-item
            label="Bitrix24 REST"
            prop="bitrix_rest"
          >
            <el-input
              id="tinymce_key"
              v-model="form.dadata_secret"
              @keyup.enter.native="submit"
            />
          </el-form-item>


          <div class="">
            <el-button
              type="success"
              native-type="submit"
              icon="el-icon-edit-outline"
            >
              Сохранить
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { VAceEditor } from 'vue3-ace-editor';

import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/theme-chrome';
import UiEditor from '@/components/Ui/UiEditor';
import BaseLayout from '@/Layouts/BaseLayout';
import UiSidebar from '@/components/Ui/UiSidebar';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiSettingsSidebar from "@Settings/Ui/UiSettingsSidebar";

export default {
  name: 'Settings',
  components: {
    UiSettingsSidebar,
    UiBreadcrumbs,
    UiSidebar,
    BaseLayout,
    UiEditor,
    VAceEditor,
  },
  props: {
    settings: { type: Array, required: true },
  },
  data() {
    return {
      form: this.$inertia.form({
        email: this.settings.email,
        phone: this.settings.phone,
        vk: this.settings.vk,
        facebook: this.settings.facebook,
        instagram: this.settings.instagram,
        tinymce_key: this.settings.tinymce_key,
        dadata_token: this.settings.dadata_token,
        dadata_secret: this.settings.dadata_secret,
        bitrix_rest: this.settings.bitrix_rest,

        example_html: this.settings.example_html,
        example_doc: this.settings.example_doc,
      }),
      sidebar_links: [
        // { title: 'Настройки', route: 'settings.settings', icon: 'el-icon-setting' },
        // { title: 'Пример', route: 'settings.directory', icon: 'el-icon-s-home' },
      ],
    };
  },
  methods: {
    submit() {
      this.form.put(route('settings.update'));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
